import { AppAssignmentEntity } from '@nohara-dxdev/oidc-core';
import { useOrgAppAssignment } from '@nohara-dxdev/react-oidc';
import { UseQueryResult } from '@tanstack/react-query';
import { PropsWithChildren } from 'react';

export interface AppAssignmentCheckProps extends PropsWithChildren {
  fallbackElement?: React.ReactNode;
  loadingElement?: React.ReactNode;
}

export const AppAssignmentCheck = ({
  children,
  fallbackElement,
  loadingElement,
}: AppAssignmentCheckProps) => {
  const {
    data: appAssignment,
    isLoading,
    isError,
  } = useOrgAppAssignment() as UseQueryResult<AppAssignmentEntity>;

  if (isLoading) {
    return loadingElement;
  }

  if (isError || appAssignment?.isDisabled) {
    return fallbackElement;
  }

  return <>{children}</>;
};
